const formatDate = (
  date: Date,
  options?: { month?: 'short' | 'long' | 'numeric' | '2-digit' | 'narrow'; year?: boolean },
) => {
  return date.toLocaleDateString('en-US', {
    year: options?.year === false ? undefined : 'numeric',
    month: options?.month || 'short',
    day: 'numeric',
  });
};

export { formatDate };
